module.exports = __webpack_public_path__ + "img/guidebook5.a7ee5333.png";